import * as Sentry from '@sentry/react'

// A bare ZodError is not diagnosable from its Sentry event: error.value is
// truncated after ~200 characters, and the production bundle reports issues as
// "Invalid input" without zod's "received <type>" clause.
const MAX_REPORTED_ISSUES = 50

function receivedType(value) {
  if (value === null) return 'null'
  if (Array.isArray(value)) return 'array'
  return typeof value
}

function valueAtPath(data, path) {
  return path.reduce((acc, key) => (acc === null || acc === undefined ? acc : acc[key]), data)
}

// Validates a response payload for reporting only: a violation is captured and
// the raw payload is handed back unchanged, so a schema that has fallen behind
// the API never breaks a screen.
export function parseOrRaw(schema, data) {
  const parsed = schema.safeParse(data)
  if (parsed.success) return parsed.data

  const { issues } = parsed.error
  Sentry.captureException(parsed.error, {
    extra: {
      issue_count: issues.length,
      issues: issues.slice(0, MAX_REPORTED_ISSUES).map((issue) => ({
        path: issue.path.join('.'),
        code: issue.code,
        expected: issue.expected,
        received: receivedType(valueAtPath(data, issue.path)),
        message: issue.message,
      })),
    },
  })
  return data
}
